import { useCallback, useEffect, useMemo, useRef } from 'react';

// One owner per workflow. Superseded/unmounted requests cannot publish results.
export function useAbortableTask() {
  const ref = useRef({ mounted: true, controller: null });
  useEffect(() => {
    const owner = ref.current;
    owner.mounted = true;
    return () => { owner.mounted = false; owner.controller?.abort(); };
  }, []);
  const cancel = useCallback(() => {
    ref.current.controller?.abort();
    ref.current.controller = null;
  }, []);
  const start = useCallback(() => {
    cancel();
    const controller = new AbortController();
    ref.current.controller = controller;
    return controller;
  }, [cancel]);
  const isCurrent = useCallback(controller => ref.current.mounted && ref.current.controller === controller && !controller.signal.aborted, []);
  return useMemo(() => ({ start, cancel, isCurrent }), [start, cancel, isCurrent]);
}